
import * as HTTP from '@/utils/http'
export default {
    /*查询文件目录（新）*/
    login(param){
        "use strict";
        return HTTP.POST('/core/api/token/v1/login', param)
    },
    //获取短信验证码
    getSmsCode(param){
        "use strict";
        return HTTP.POST(`/core/api/captcha/v1/sms/sms-code`, param)
    },
    //手机短信验证码登录
    smsLogin(param){
        "use strict";
        return HTTP.POST(`/core/api/token/v1/sms-login`, param)
    },
    //手机短信验证码注册
    smsRegister(param){
        "use strict";
        return HTTP.POST(`/core/api/token/v1/sms-register`, param)
    },
    //获取用户信息
    getUserInfo(param){
        "use strict";
        return HTTP.GET(`/core/api/user-profile/v1`, param)
    },
    //修改用户信息
    editUserInfo(param){
        "use strict";
        return HTTP.PUT(`/core/api/user-profile/v1`, param)
    },
    //退出登录
    logout(param){
        "use strict";
        return HTTP.DELETE(`/core/api/token/v1/logout`, param)
    },
    //获取会员信息
    getMemberInfo(param){
        "use strict";
        return HTTP.GET(`/core/api/member/v1/info`, param)
    },
    //获取文件地址
    getFileUrl(id){
        "use strict";
        return HTTP.GET(`/doc/api/file/preview?fileId=${id}`)
    },
    //获取文件地址
    getDownloadFileUrl(param){
        "use strict";
        return HTTP.POST(`/physical-file/physical/file/download/url`,param)
    },
    //更换用户头象
    editAvatar(id){
        "use strict";
        return HTTP.POST(`/core/api/user-profile/v1/avatar?avatarFileId=${id}`)
    },
    //轮询用户扫码状态
    timerGetCodeStatus(code){
        "use strict";
        return HTTP.GET(`/core/api/wx/v1/code/info?qrCode=${code}`)
    },
    getSignatureInfo(param){
        "use strict";
        return HTTP.POST(`/core/api/wx/v1/xcxGetSignatureInfo`, param)
    },
    // 获取邀请链接
    getInviteLink(){
        "use strict";
        return HTTP.GET(`/core/api/points/v1/invite-info`)
    },
    getPointInfo(){
        "use strict";
        return HTTP.GET(`/core/api/points/v1/info`)
    },
    getPointList(param){
        "use strict";
        return HTTP.POST(`/core/api/points/v1/log/list`, param)
    },
    getBreakdown(param){
        "use strict";
        return HTTP.GET(`/core/api/points/v1/breakdown`)
    },


}


